import WaitlistForm from "../components/WaitlistForm";
import Reveal from "../components/Reveal";

export default function ElderSanctuary() {
  return (
    <>
      <section className="container-prose pt-16 sm:pt-24 pb-10 relative">
        <div
          aria-hidden
          className="orb -top-20 -left-20 h-72 w-72 animate-float"
          style={{ background: "radial-gradient(closest-side, #ffc6a3, transparent)" }}
        />
        <Reveal>
          <span className="pill pill-peach">Program 01 · Elder Sanctuary</span>
          <h1 className="mt-5 font-display text-5xl sm:text-6xl leading-[1.02] text-balance">
            A home for elders who have <em className="not-italic grad-text">no one left.</em>
          </h1>
          <p className="mt-6 text-lg text-ink-500 leading-relaxed">
            Our Elder Sanctuary is a residential home for older people who have
            been left without family, shelter, or means. A bed, three meals,
            regular medicine, a community, and the simple dignity of being
            remembered at dawn and at dusk. Entry is free for life. No one is
            ever asked to leave.
          </p>
        </Reveal>
      </section>

      <section className="container-prose py-10">
        <div className="grid gap-5 sm:grid-cols-3">
          {[
            { h: "Who it's for", t: "Elders (typically 60+) with no living family or caretaker, homeless or at imminent risk of homelessness." },
            { h: "What's included", t: "Shelter, meals, medicine, medical visits, clothing, community — for life." },
            { h: "What's required", t: "Nothing. We verify situation during intake; that's all." },
          ].map((b, i) => (
            <Reveal key={b.h} delay={i * 100}>
              <div className="surface h-full">
                <h3 className="font-display text-xl">{b.h}</h3>
                <p className="mt-2 text-ink-500 text-sm leading-relaxed">{b.t}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="container-prose py-10">
        <Reveal>
          <div className="glass-strong rounded-3xl p-8 sm:p-10 relative overflow-hidden">
            <div
              aria-hidden
              className="absolute -top-16 -right-16 h-56 w-56 rounded-full blur-3xl opacity-50"
              style={{ background: "radial-gradient(closest-side, #ffb6cb, transparent)" }}
            />
            <h2 className="font-display text-3xl">How intake works</h2>
            <ol className="mt-5 space-y-3 text-ink-700 text-sm">
              {[
                "You join the waitlist using the form below.",
                "A Sanctology caseworker calls to understand the situation and urgency.",
                "We schedule an in-person visit or receive transfer from a partner NGO or social worker.",
                "When a place is ready, we welcome the elder home.",
              ].map((step, i) => (
                <li key={i} className="flex gap-3 items-start">
                  <span className="shrink-0 mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-white text-peach-glow font-mono text-xs font-semibold border border-peach-200">
                    {i + 1}
                  </span>
                  <span className="leading-relaxed">{step}</span>
                </li>
              ))}
            </ol>
          </div>
        </Reveal>
      </section>

      <section id="waitlist" className="container-prose pt-10 pb-24">
        <Reveal>
          <div className="mb-6">
            <h2 className="font-display text-4xl">
              Join the Elder Sanctuary waitlist
            </h2>
            <p className="mt-3 text-ink-500 leading-relaxed">
              Fill this out for yourself, a relative, a neighbour you're
              worried about, or a case you're helping with. The more you tell
              us, the faster we can act.
            </p>
          </div>
        </Reveal>
        <Reveal delay={100}>
          <WaitlistForm program="elder" />
        </Reveal>
      </section>
    </>
  );
}
